import { NavigationHelperService } from 'src/app/shared/helpers/navigation.helpers.service';
import { BannerType } from './../../models/banner-type.enum';
import { BannerTitle } from './../../models/banner-title.model';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { Banners, RichTextMainList, SearchResponse } from '@usf/product-types';
import { PATHS } from 'src/app/shared/constants/paths';
import { UsfProductCardModeEnum } from 'src/app/shared/constants/usf-product-card-mode.enum';
import { SearchService } from '@search/services/search.service';
import { getImageIdFromUrl } from '@search/utils/search-url-images.util';

@Component({
  selector: 'app-search-banner',
  templateUrl: './search-banner.component.html',
  styleUrls: ['./search-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBannerComponent implements OnInit, OnChanges {
  readonly type = BannerType;

  @Input() leftTitleConfig: BannerTitle;
  @Input() bannerType: string;
  @Input() termSearched: string;
  @Input() searchResponse: SearchResponse;
  @Output() updateSearchText = new EventEmitter();

  originalTerm = '';
  productItems: RichTextMainList[] = [];

  constructor(
    private navigationHelper: NavigationHelperService,
    private searchService: SearchService,
  ) {}

  ngOnInit(): void {
    this.updateBanner();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.termSearched?.currentValue) {
      this.updateBanner();
    }
  }

  updateBanner() {
    const { richTextMainList = [] } = this.searchResponse;
    this.productItems = richTextMainList.reduce((list, banner) => {
      if (banner['@type'] === this.bannerType) {
        /** Filter Valid Banners */
        const validBanners = banner.banners.filter(
          ban => ban.slotName && ban.deepLinkFilterProperties,
        );
        if (validBanners.length > 0) {
          list = [...list, { ...banner, banners: validBanners }];
        }
      }
      return list;
    }, []);
  }
  getDefaultImage(event: Event) {
    const image = event.target as HTMLImageElement;
    image.src = '/assets/images/no-image.svg';
    image.className = 'error-image';
  }
  searchBannerProduct(bannerInformation: Banners, stickyGroup: boolean) {
    const imageId = getImageIdFromUrl(bannerInformation.imageURL);
    this.searchService.trackVisualCartridgeBanner(imageId);

    const termSearched =
      this.termSearched || this.searchResponse?.didYouMean?.originalTerm;
    this.navigationHelper.routeTo(PATHS.SEARCH, {
      searchText: termSearched,
      mode: UsfProductCardModeEnum.bannerSearch,
      deepLinkFilterProperties: bannerInformation.deepLinkFilterProperties,
      isSticky: bannerInformation.stickyEnabled,
      bannerSearchTerm: bannerInformation.searchBannerText.trim(),
      isGroupSticky: stickyGroup,
      deepLinkFlow: true,
      contentSequence: bannerInformation.contentSequence,
    });
    // text in UI
    this.updateSearchText.emit(
      `${termSearched} + ${bannerInformation.slotName}`,
    );
  }
}
